export default __webpack_public_path__ + "static/media/sponsor-icon-bottom-nav-mobile-active.b305bf1e.webp";